export const routes = [
  {
    path: '/about',
    name: 'About',
    component: () => import ('@/views/about/page.vue')
  }
]
